import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { BooleanFilter } from 'components/Filter/BooleanFilter'
import { ModalFilter } from 'components/Filter/ModalFilter'
import { FilterDescriptor } from 'store/grid'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { SelectVersion } from '../SelectVersion'

const VersionFilter = ({
  filter,
  onFilterChange,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}) => {
  if (
    filter.operator === GridFilterOperatorEnum.isEmptyOperator ||
    filter.operator === GridFilterOperatorEnum.isNotEmptyOperator
  )
    return null
  return (
    <ModalFilter
      Modal={SelectVersion}
      placeholder='Choose Version'
      filter={filter}
      onFilterChange={onFilterChange}
    />
  )
}

export const getFeatureFlagFilterFields = (): FieldSettings[] => [
  {
    name: 'Name',
    label: 'Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.startsWithOperator,
        operator: GridFilterOperatorEnum.startsWithOperator,
      },
    ],
  },
  {
    name: 'IsEnabledDefault',
    label: 'Enabled',
    filter: BooleanFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: 'Version',
    label: 'Version',
    filter: VersionFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.isEmptyOperator,
        operator: GridFilterOperatorEnum.isEmptyOperator,
      },
      {
        text: GridFilterOperatorNameEnum.isNotEmptyOperator,
        operator: GridFilterOperatorEnum.isNotEmptyOperator,
      },
    ],
  },
]
